declare namespace $ {

	type $mol_view__sub_bog_ui_app_skeleton_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_skeleton_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_skeleton_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_skeleton_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_skeleton_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_skeleton_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_skeleton extends $mol_page {
		description( ): string
		Description( ): $mol_view
		section_single_title( ): string
		Section_single( ): $mol_view
		Single( ): $bog_ui_skeleton
		section_card_title( ): string
		Section_card( ): $mol_view
		Card_avatar( ): $bog_ui_skeleton
		Card_title( ): $bog_ui_skeleton
		Card_line1( ): $bog_ui_skeleton
		Card_line2( ): $bog_ui_skeleton
		Card_short( ): $bog_ui_skeleton
		Card( ): $mol_view
		section_sizes_title( ): string
		Section_sizes( ): $mol_view
		Size_small( ): $bog_ui_skeleton
		Size_medium( ): $bog_ui_skeleton
		Size_large( ): $bog_ui_skeleton
		Sizes( ): $mol_view
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=skeleton.view.tree.d.ts.map